import React from 'react';
import './css/Table.css';
import { Table } from 'antd';

const TableAnt = ({ isIndia, columns, data, width, height }) => (
    <Table
        // tableLayout='auto'
        className={isIndia ? 'indiaTable' : 'stateTable'}
        columns={columns} dataSource={data} showSorterTooltip={false}
        bordered pagination={false} scroll={{ x: width/2, y: height }}
        summary={pageData => {
            let summaryArray = [];
            for(let i=1;i<columns.length;i++) {
                summaryArray.push(0);
            }
            console.log('pageData=',pageData);
            console.log('columns==',columns);
            try {
                let leadSum = 0;
                pageData.forEach(item => {
                    // console.log('row item=',item);
                    for(let i=2;i<columns.length;i++) {
                        let { title } = columns[i];
                        let value = item[title];
                        if(i>1) {
                            value = parseInt(value.split('\n')[0]);
                        }
                        summaryArray[i-1] += value;
                        leadSum += value;
                    }
                    summaryArray[0] = leadSum;
                });
            } catch(e) {
                console.log('table error=',e);
            }
            console.log('summaryArray==',summaryArray);
            if(isIndia||columns.length<3) {
                return;
            }
            return (
              <Table.Summary fixed>
                    <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>
                            <div style={{ backgroundColor: '#F5F6FF' }}>
                            Total
                            </div>
                        </Table.Summary.Cell>
                        {summaryArray.map((item, index) => 
                            <Table.Summary.Cell key={index} index={index+1}>
                                <div>{item}</div>
                            </Table.Summary.Cell>
                        )}
                    </Table.Summary.Row>
              </Table.Summary>
            );
          }}
    />
);

export default TableAnt;